import CryptoJS from 'crypto-js';

const cryptoKey: string = "bizmed-web-app-key";

const encrypt = (txt: string): string => {
    try {
        return CryptoJS.AES.encrypt(txt, cryptoKey).toString();
    } catch (e) {
        console.error("Encryption error:", e);
        throw e;
    }
};

const decrypt = (txt: string): string => {
    try {
        const bytes = CryptoJS.AES.decrypt(txt, cryptoKey);
        return bytes.toString(CryptoJS.enc.Utf8);
    } catch (e) {
        console.error("Decryption error:", e);
        return "";
    }
};

const storage = {
    saveLocalStorage: (key: string, value: string): void => {
        try {
            const encryptedValue = encrypt(value);
            localStorage.setItem(key, encryptedValue);
        } catch (e) {
            console.error(`Error saving encrypted item to localStorage for key "${key}":`, e);
        }
    },
    getLocalStorage: (key: string): string | null => {
        try {
            const encryptedValue = localStorage.getItem(key);
            if (encryptedValue) {
                const decryptedValue = decrypt(encryptedValue);
                return decryptedValue === "" ? null : decryptedValue;
            } else {
                return null;
            }
        } catch (e) {
            console.error(`Error retrieving or decrypting item from localStorage for key "${key}":`, e);
            return null;
        }
    },
    removeLocalStorage: (key: string): void => {
        try {
            localStorage.removeItem(key);
        } catch (e) {
            console.error(`Error removing item from localStorage for key "${key}":`, e);
        }
    }
};

export default storage;